// Public frontend settings only. This module also validates env before compilation.
function required(name, value) {
    if (typeof value !== 'string' || !value.trim()) {
        throw new Error('Missing ' + name + '. Use npm run build:onpublic or npm run build:onprem.');
    }
    return value.trim();
}
function httpUrl(name, value) {
    const result = required(name, value).replace(/\/+$/, '');
    if (!/^https?:\/\/[^\s/?#]+(?::\d+)?(?:\/[^\s?#]*)?$/.test(result)) {
        throw new Error(name + ' must be an HTTP(S) URL without query or fragment.');
    }
    return result;
}
const backendUrl = httpUrl('VUE_APP_BACKEND_URL', process.env.VUE_APP_BACKEND_URL);
const socketUrl = httpUrl('VUE_APP_SOCKET_URL', process.env.VUE_APP_SOCKET_URL);
const imrLocal = required('VUE_APP_CALL_IMR_LOCAL', process.env.VUE_APP_CALL_IMR_LOCAL);
const callFrom = required('VUE_APP_CALL_FROM', process.env.VUE_APP_CALL_FROM);
if (imrLocal !== 'true' && imrLocal !== 'false') {
    throw new Error('VUE_APP_CALL_IMR_LOCAL must be true or false.');
}
if (!/^[012]$/.test(callFrom)) {
    throw new Error('VUE_APP_CALL_FROM must be 0, 1 or 2.');
}
module.exports = Object.freeze({
    backendUrl,
    socketUrl,
    callImrLocal: imrLocal === 'true',
    callFrom: Number(callFrom),
    avatarUrl: backendUrl + '/static/uploads',
    cbcImagesUrl: backendUrl + '/static/lab_img_cbc/',
    newsV2Url: backendUrl + '/static/lab_news/',
    // Legacy news uploader in resources/news.py uses this separate directory.
    newsUrl: backendUrl + '/static/uploads/imges_news'
});